export const LiffURL = "https://liff.line.me/1655947712-lrVP4jvW";
export const LiffURL2 = "https://liff.line.me/1656147561-x02qRGv3";
export const LIFFURL_CMUH = "https://liff.line.me/1656082168-XG34P3ye";